// src/auth.js
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // undefined = tjekker stadig, null = ikke logget ind
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    axios.get('/api/auth/me')
      .then(res => setUser(res.data.user))
      .catch(() => setUser(null));
  }, []);

  // Udløbet session midt i arbejdet -> tilbage til login
  useEffect(() => {
    const id = axios.interceptors.response.use(
      res => res,
      err => {
        const url = err.config?.url || '';
        if (err.response?.status === 401 && !url.startsWith('/api/auth/') && !url.startsWith('/api/invite/')) {
          setUser(null);
        }
        return Promise.reject(err);
      }
    );
    return () => axios.interceptors.response.eject(id);
  }, []);

  const login = useCallback(async (username, password) => {
    const res = await axios.post('/api/auth/login', { username, password });
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const acceptLink = useCallback(async (token, password) => {
    const res = await axios.post(`/api/invite/${encodeURIComponent(token)}`, { password });
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await axios.post('/api/auth/logout');
    } finally {
      setUser(null);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, acceptLink }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function RequireAuth({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) return null;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}

export function RequireAdmin({ children }) {
  const { user } = useAuth();
  if (user && user.role !== 'admin') return <Navigate to="/calculator" replace />;
  return <RequireAuth>{children}</RequireAuth>;
}
